import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastifyComponent = () => <ToastContainer />;

export default ToastifyComponent;
